<template>
  <modal
    v-slot="{ data }"
    name="requestTwoFactorAuthPasscodeModal"
    modal-style="compact"
  >
    <request-two-factor-auth-passcode
      v-bind="data"
      :on-success="data.onSuccess"
    />
  </modal>
</template>


<script>
  import RequestTwoFactorAuthPasscode from './request-two-factor-auth-passcode/index.vue';


  export default {
    name: 'RequestTwoFactorAuthPasscodeModal',

    components: {
      RequestTwoFactorAuthPasscode
    }
  };
</script>
